import { render, staticRenderFns } from "./EmailDetailInfo.vue?vue&type=template&id=184f6299&"
import script from "./EmailDetailInfo.vue?vue&type=script&lang=ts&"
export * from "./EmailDetailInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports